module.exports = __webpack_public_path__ + "img/font-bg.dc3f7829.svg";